export const API_CONNECTIONS_DESCRIPTION =
  'Call web services and webhooks over HTTPS, such as a dealer’s or partner’s API, from workflows.'
